import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto'; // Self-hosted Roboto; no font requests to Google
import './index.css';
import './firebaseConfig'; // Initialize Firebase before App renders
import App from './App';
import { startConsentedServices } from './Util/PrivacyConsent';
//import registerServiceWorker from './registerServiceWorker';

startConsentedServices();
ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
